import React, { useMemo,useEffect,useState } from "react";

//import components
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
import { DateTime } from 'luxon';
import axios from "axios"
import { Card, CardBody ,Alert, Modal, ModalHeader,Row,Col,Label,UncontrolledDropdown,
  DropdownToggle,DropdownMenu,Badge} from "reactstrap";
import emailInbox from "pages/Email/email-inbox";
const baseUrl = process.env.REACT_APP_BASE_URL;

// interface column {
//     header: string,
//     accessorKey: string,
//     enableColumnFilter: boolean,
//     enableSorting: boolean,
// }

interface column {
  header: string;
  accessorKey?: string;
  accessorFn?: (row: any) => string;
  enableColumnFilter: boolean;
  enableSorting: boolean;
  cell?: (info: any) => React.ReactNode;
}



const Cbookings = () => {

  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; }
      setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const [modal_center, setmodal_center] = useState(false);
  const [policy_check, setpolicy_check] = useState<{ [key: string]: boolean }>({});
  const [Alert_cancel, setAlert_cancel] = useState<{ [key: string]: boolean }>({});
  const [book_button_cancel, setbook_button_cancel] = useState<{ [key: string]: boolean }>({});
  console.log('policy_check_______________________________',policy_check)
  const [bookings, setBookings] = useState<any[]>([]);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [targetBookingId, setTargetBookingId] = useState<string | null>(null);
  const [targetPolicy, setTargetPolicy] = useState<any>(null);
  const [TimeExpire, setTimExpire] = useState<any>(null);
  console.log('targetBookingId',targetBookingId)
  console.log('targetPolicy',targetPolicy)
  console.log('TimeExpire',TimeExpire)

  useEffect(() => {
  }, [bookings]);

  const fetch_bookings = async () => {
    try {
      setshowloader(true)
      const response = await axios.post( 'bookings/customer_bookings', {}, { withCredentials: true } );
      if (response.status === 'SENT') {
        window.dispatchEvent(new Event("cartLengthUpdated"));
        console.log('response check krna h ',response )
        console.log('cart_count dekhna h ',response.cart_count)
        localStorage.setItem('cart_length',response.cart_count)
        const policyFlags: { [key: string]: boolean } = {};
        const Alert_cancelation: { [key: string]: boolean } = {};
        const cancel__booking: { [key: string]: boolean } = {};


        // response.bookings.forEach((item: any) => {
        //   policyFlags[item.id] = item.is_cancellation_allowed;
        // });

        response.bookings.forEach((item:any) => {
          const {id, seldate, seltimes, expert, timezone} = item;
          console.log('ye chala timezone----',item.id,item.expert.timezone,seldate,seltimes.hour)
          const policyHours = parseInt(expert.policy_time) || 0;
          console.log("policyHours----",policyHours)
          const bookingDateTime = DateTime.fromFormat(
            `${seldate} ${seltimes.hour}`,
            'yyyy-MM-dd h:mm a',
            { zone: timezone || 'UTC' }
          );
          console.log('bookingDateTime----11---',bookingDateTime)
          const now = DateTime.now().setZone(timezone || 'UTC');

          const cutoffTime = bookingDateTime.minus({hours: policyHours})
          const isAllowed = now < cutoffTime;
          console.log('Booking ID:', id);
          
          console.log('Booking DateTime:', bookingDateTime.toISO());
          console.log('Now in server current Timezone:', now.toISO());


          console.log('after policy miuus :', cutoffTime.toISO());
          console.log('Cancellation Allowed:', isAllowed);
          const book_buuton = now > bookingDateTime
          policyFlags[id] = !isAllowed
          Alert_cancelation[id] = isAllowed
          cancel__booking[id] = book_buuton
          console.log('Cancellation error buuton---',Alert_cancelation[id],Alert_cancelation)
          console.log('Cancellation Allowed again:', policyFlags[id],policyFlags);
          console.log('cancel__booking:', cancel__booking[id] ,cancel__booking);
          
        })

        setpolicy_check(policyFlags);
        setAlert_cancel(Alert_cancelation);
        setbook_button_cancel(cancel__booking)
        setshowloader(false)

        setBookings(response.bookings);
      }
    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }
  };
    
  useEffect(() => {
    fetch_bookings();
    subscribeToTokenRefresh(() => {
      console.log("🔁 Token refreshed. Re-fetching experts...");
      fetch_bookings();
    });
  }, []);
  
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [selectedBookingId, setSelectedBookingId] = useState<string | null>(null);


  function bookinginfo(id : string){
    console.log('Booking ID clicked:', id, bookings, Date.now()); 
    if (!bookings || bookings.length === 0) return;
    const booking = bookings.find(b => b.id === id);
    if (booking){
      setSelectedBooking({
      first_name : booking.expert?.user?.first_name || '',
      last_name  : booking.expert?.user?.last_name || '',
      email      : booking.expert?.user?.email || '',
      phone      : booking.expert?.user?.phone || '',
      booking_date : booking.seldate || '',
      category    : booking.expert?.category || '',
      session     : booking.exp_session_mins || '',
      status      : booking.status || '' ,
      zoom_url    : booking.zoom?.join_url || '',
      price       : booking.expert_price || '',
    })
    setSelectedImage(booking.expert?.user?.profile_pic || null);
    setSelectedBookingId(id);
    setmodal_center(true);
  }else {
    console.log('No Data Foynd in Bokkings.')
  }
  }
  const columns: column[] = useMemo(
    () => [
          {
              header: '#ID',
              accessorKey: 'id',
              enableColumnFilter: false,
              enableSorting: true,
          },
          {
            header: 'Expert Info',
            accessorFn: (row: any) => {
              const first_name = row?.expert?.user?.first_name || '';
              const email = row?.expert?.user?.email || '';
              return `${first_name} ${email}`;
            },
            enableColumnFilter: false,
            enableSorting: true,
            cell: (info: any) => {
              const row = info.row.original;
              const first_name = row?.expert?.user?.first_name;
              const email = row?.expert?.user?.email;
              const attachment = row?.expert?.user?.profile_pic;
              return (
                <div className="d-flex align-items-center">
                  {/* {attachment && (
                    <img
                      src={`${baseUrl}${attachment}`}
                      alt="attachment"
                      width="50"
                      height="50"
                      className="rounded-circle"
                      style={{ marginRight: '10px' }}
                    />
                  )} */}
                  <img
                      src={attachment ? `${baseUrl}${attachment}` : defaultUserImg}
                      alt="attachment"
                      width="50"
                      height="50"
                      className="rounded-circle"
                      style={{ marginRight: '10px' }}
                    />
                  <div>
                    <div className="fw-medium">{first_name || "No first name"}</div>
                    <div className="font-size-12">{email || "No email"}</div>
                  </div>
                </div>
              );
            }
          },
          
          {
              header: 'Phone',
              accessorKey: 'expert.user.phone',
              enableColumnFilter: false,
              enableSorting: true,
          },
          {
              header: 'Booking Date',
              accessorKey: 'seldate',
              enableColumnFilter: false,
              enableSorting: true,
              cell: ({ row }: any) => { return ( <> {row.original.seldate} <br /> {row.original.seltimes?.hour} </> ); },
          },
          {
              header: 'Category',
              accessorKey: 'expert.category',
              enableColumnFilter: false,
              enableSorting: true,
              cell: ({ row }: any) => {
                  const category = row.original.expert?.category;
                  if (category) {
                    const subcategories = row.original.expert?.subcategory.name;
              
                    return (
                      <>
                        {category.name} <br /> {subcategories}  
                      </>
                    );
                  }
                  return 'No category available';  
                },
          },
          {
              header: 'Session',
              accessorKey: 'expert.packs',
              enableColumnFilter: false,
              enableSorting: true,
              cell: ({ row }: any) => {return `$${row.original?.expert_price} / ${row.original?.exp_session_mins} Mins`},
          },
          // {
          //   header: 'Purpose',
          //   accessorKey: 'purpose',
          //   enableColumnFilter: false,
          //   enableSorting: true,
          // },
          {
              header: 'Status',
              accessorKey: 'status',
              enableColumnFilter: false,
              enableSorting: true,
              cell: (cellProps: any) => {
                  const rawStatus = cellProps.row.original?.status;
                  const statusClassMap: Record<string, string> = {
                      cancelnrefund: 'danger',
                      booked: 'success',
                      failed: 'dark',
                      requested: 'warning',
                      cancle: 'danger'
                  };
                  const badgeClass = statusClassMap[rawStatus] || 'secondary';
          
                  return (
                      <Badge className={`font-size-11 badge-soft-${badgeClass}`}>
                          {rawStatus ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1) : 'N/A'}
                      </Badge>
                  );
              },
          },
          {
            header: 'Action',
            accessorKey: 'id', 
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }: any) => {
              const id = row.original.id;
              const isDisabled = !row.original;
              return (
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={() => bookinginfo(id)}
                    disabled={isDisabled}
                  >
                    <i className="bx bx-show-alt mx-1" ></i>
                    View
                  </button>
                </div>
              );
            }
          }

      ],
      [bookings]
  );



  const bookingCancel = async (bookingId: string | null, isCancellationAllowed: boolean ,TimeExpire:boolean) => {
    setshowloader(true)
    console.log('bookingId',bookingId,'---------','policy_check',policy_check,'isCancellationAllowed',isCancellationAllowed)
    console.log('TimeExpire --------- ',TimeExpire)

    if (!bookingId) {
      console.warn("❌ Booking ID not provided.");
      return;
    }

    console.log("✅ Proceeding to cancel booking ID:", bookingId,isCancellationAllowed);
    try{
      const response = await axios.post('/bookings/cancel_booking',{'booking_id':bookingId,'policy_cancel':isCancellationAllowed},{ withCredentials: true})
      console.log('response',response)
      if (response.status === "Payemnt Refund"){
          console.log('yes payment refund hone lag gyi h ')
          fetch_bookings()
          setTimeout(()=>{
            setmodal_center(false)
          }, 1200)
          setshowloader(false)
      } else {
        fetch_bookings()
        setTimeout(()=>{
            setmodal_center(false)
            setshowloader(false)
          }, 1200)
      }

    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
            console.log('Error stripe payment')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    
  }};


  //meta title
  document.title = "Bookings | BizServe";


  return (
      <div className="page-content">
          <div className="container-fluid">
            {alertMsgg.open && (
            <Alert 
            color={alertMsgg.type === "success" ? "success" : "danger"} 
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>
              <Breadcrumbs title="Customer" breadcrumbItem="My Bookings with Experts" />
              <Card>
                <CardBody>
                  <div className="floatInfo">
                    <UncontrolledDropdown>
                        <DropdownToggle type="button" className="btn btn-soft-primary btn-sm btnCircle">
                            <i className="bx bx-info-circle font-size-18"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-lg p-3">
                        <table className="table table-sm mb-0">
                            <thead>
                                <tr>
                                    <th colSpan={2} className="text-center">Legend</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={2} className="fw-bold text-center">Status</td>
                                </tr>
                                <tr>
                                    <td><Badge className="font-size-11 badge-soft-danger">cancelnrefund</Badge></td>
                                    <td>Booking has been cancelled and the payment has been refunded.</td>
                                </tr>
                                <tr>
                                    <td><Badge className="font-size-11 badge-soft-warning">requested</Badge></td>
                                    <td>Requested.</td>
                                </tr>
                                <tr> 
                                    <td><Badge className="font-size-11 badge-soft-danger">cancelled</Badge></td>
                                    <td>Booking has been cancelled. Payment is non-refundable.</td>
                                </tr>
                                <tr>
                                    <td><Badge className="font-size-11 badge-soft-success">booked</Badge></td>
                                    <td>Booked</td>
                                </tr>
                                <tr>
                                    <td><Badge className="font-size-11 badge-soft-secondary">failed</Badge></td>
                                    <td>Booking request has failed.</td>
                                </tr>
                                
                            </tbody>
                        </table>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
                    <TableContainer
                        columns={columns}
                        data={bookings || []}
                        isGlobalFilter={true}
                        isPagination={true}
                        SearchPlaceholder="Search By Name..."
                        pagination="pagination"
                        paginationWrapper='dataTables_paginate paging_simple_numbers'
                        tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                    />
                </CardBody>
              </Card>
          </div>
          <Modal
            isOpen={modal_center}
            toggle={() => setmodal_center(false)}
            backdrop={'static'}
            id="staticBackdrop"
            centered
            size="md"
            className="rounded-4"
            >
          
          <ModalHeader className="py-3 px-4" toggle={() => setmodal_center(false)} >
            <div className="modal-title mt-0 font-size-20 text-dark">Booking Data</div>
          </ModalHeader>
          <div className="modal-body p-4">
            {selectedBookingId !== null && selectedBooking?.status && !["cancelnrefund", "cancelled", "cancle", "requested"].includes(selectedBooking.status) &&  (
                <div className="d-flex flex-column gap-2 mb-3">
                   {/* {!policy_check[selectedBookingId] && Alert_cancel[selectedBookingId] && ( */}
                  { !book_button_cancel[selectedBookingId] && !Alert_cancel[selectedBookingId] && (
                    <p
                      className="text-warning mt-1"
                      style={{
                        backgroundColor: '#fff3cd',
                        color: '#856404',
                        padding: '10px 15px',
                        borderRadius: '6px',
                        border: '1px solid #ffeeba',
                        fontWeight: 500,
                      }}
                    >
                    This booking is outside the cancellation window. It may not be refunded.
                    </p>
                  )}

    

                </div>
              )}
              
            <Row>

              <Col md="12">
              <div className="mb-3 border-bottom pb-3 text-center">
                <div className="text-center mb-2">
                  <div className="position-relative d-inline-block">
                    <div className="position-relative bottom-0 end-0">
                        <div className="avatar-lg">
                          <div className="avatar-title bg-light rounded-circle">
                            <img 
                              src={selectedImage || defaultUserImg}  
                              id="edit-projectlogo-img" 
                              alt="" 
                              className="avatar-md rounded-circle object-fit-cover" 
                            />
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <Label className="form-label">Expert Image</Label>
              </div>

              
              </Col>

              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Expert Name</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.first_name || 'N/A'}  {selectedBooking?.last_name || 'N/A'}
                  </div>
                </div>
              </Col>
              
              
              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Email</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.email || 'N/A'}
                  </div>
                </div>
              </Col>


              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Phone</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.phone || 'N/A'}
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Booking Date</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.booking_date || 'N/A'}
                  </div>
                </div>
              </Col>

            
              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Category</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.category?.name || 'N/A'}
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Session</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.session || 'N/A'} Mins
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Price</label>
                  <div className="form-control-plaintext pt-0">
                    $ {selectedBooking?.price || 'N/A'} 
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-4">
                  <label className="form-label mb-0">Status</label>
                  <div className="form-control-plaintext pt-0">
                    {selectedBooking?.status || 'N/A'}
                  </div>
                </div>
              </Col>

              <Col lg={12}>
                <div className="mb-4">
                  <label className="form-label mb-0">Zoom URL</label>
                  <div className="form-control-plaintext pt-0">
                    <a href="selectedBooking?.zoom_url">
                      
                      {selectedBooking?.zoom_url || 'N/A'}
                    </a>
                  </div>
                </div>
              </Col>
              
              <Col lg={12}>
                {selectedBookingId !== null && selectedBooking?.status && !["cancelnrefund", "cancelled","cancle", "requested"].includes(selectedBooking.status) && !book_button_cancel[selectedBookingId]  &&(
                  <div className="d-flex flex-start gap-2 mb-3">
                    <button
                      className="btn btn-danger btn-sm"
                      // onClick={() => bookingCancel(selectedBookingId, policy_check[selectedBookingId])}
                      onClick={() => {
                        setTargetBookingId(selectedBookingId);
                        setTargetPolicy(policy_check[selectedBookingId]);
                        setTimExpire(book_button_cancel);
                        setShowCancelModal(true);
                      }}
                    >
                      Cancel Booking
                    </button>
                  </div>
                )}
              </Col>

              {/* <div className="d-flex gap-2">
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-dark btn-sm"
                      >
                        <i className="bx"></i>
                        Cancel #{selectedBookingId} -- {policy_check}
                      </button>
                    </div>
                
                </div> */}

            </Row>
            
          </div>
          {showCancelModal && (<>
              <div style={{position: "fixed",top: 0,left: 0,width: "100vw",height: "100vh",backgroundColor: "rgba(0,0,0,0.5)",zIndex: 999,
                }}
                onClick={() => setShowCancelModal(false)} 
              ></div>

              <div style={{position: "fixed",top: "50%",left: "50%",transform: "translate(-50%, -50%)",backgroundColor: "#fff",borderRadius: "20px",zIndex: 1000,width: "90%",maxWidth: "440px",boxShadow: "0 10px 30px rgba(0,0,0,0.3)",padding: "4px"}}>
                <div className="modal-header d-flex justify-content-between align-items-center">
                  <h5 className="modal-title">Confirm Cancellation</h5>
                  <button className="btn-close" onClick={() => setShowCancelModal(false)}></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to cancel this booking?</p>
                </div>
                <div className="modal-footer d-flex justify-content-end gap-2">
                  <button className="btn btn-secondary" onClick={() => setShowCancelModal(false)}>
                    No
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      bookingCancel(targetBookingId, targetPolicy ,TimeExpire);
                      setShowCancelModal(false);
                    }}
                  >
                    Yes, Cancel
                  </button>
                </div>
              </div>
            </>
          )}
        </Modal>

      </div>
  );
}
export default Cbookings;